import { action } from 'mobx';

import type { BicData } from '../../model';

export const getBankNameByBic = action(
  (bicData: BicData[] | undefined, bic: string): string | undefined =>
    bicData?.find((item) => item.bic === bic)?.name
);
